<template>
  <div id="app">
    <div class="FullScreenWrapper">
      <div class="ContentContainer">  
        
        <div class="LoginBox" v-if="!isAuthenticated">
          <h1>Iconics server rebooter</h1>
          <div>
            <button @click="login" class="LoginButton">Login with Microsoft</button>
          </div>
          
        </div>
        <div v-else>
          <p>Welcome, {{ userName }}!</p>

          <restartButton></restartButton>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import restartButton from './components/restartButton.vue';


export default {
  data() {
    return {
      isAuthenticated: false,
      userName: ''
    };
  },
  components: {
    restartButton
  },
  mounted() {
    this.checkAccount();
  },
  methods: {
    async login() {
      try {
        const loginResponse = await this.$msalInstance.loginPopup({
          scopes: ['user.read']
        });
        this.isAuthenticated = true;
        this.userName = loginResponse.account.name;
      } catch (error) {
        console.error('Login error:', error);
      }
    },
    async checkAccount() {
      const accounts = this.$msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        this.isAuthenticated = true;
        this.userName = accounts[0].name;
      }
    },
    logout() {
      this.$msalInstance.logout();
      this.isAuthenticated = false;
      this.userName = '';
    },
    async callApi(apiName,apiBody) {
      try {
        const response = await fetch(apiName, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: apiBody
        });
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      } catch (error) {
        console.error('API call error:', error);
      }
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 60px;
}
.FullScreenWrapper{
  display: flex;
  justify-content: center;
  align-items: center;
  
  height: 100vh;
  width: 100vw;
}
.ContentContainer{
  width: 700px;
  height: 600px;
  margin-top: 10px;
  background-color: #f0f0f0;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  padding: 20px;
}
.LoginButton {
  background-color: #5f9ba8;
  color: white;
  border: none;
  width: 300px;
  height: 100px;
  font-weight: bolder;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 24px;
  cursor: pointer;
}
.LoginBox {
  width: 100%;
  height: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
